<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="工序"
      edit-title
      id-key="UserId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row class="border">
          <el-row :gutter="15">
            <el-col>
              <el-form-item label="工序编码" prop="ProcessNo">
                <el-input :disabled="disabled" v-model="data.ProcessNo" placeholder="请输入工序编码" />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="工序名称" prop="ProcessName">
                <el-input v-model="data.ProcessName" placeholder="请输入工序名称" />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="加工阶段" prop="Stage">
                <!-- <el-select
                  :disabled="disabled"
                  clearable
                  v-model="data.Stage"
                  @change="setSn"
                  placeholder="请选择加工阶段"
                >
                  <el-option
                    v-for="item in ProductionPhaseOptions"
                    :key="item.DictionaryId"
                    :label="item.ItemText"
                    :value="item.ItemValue"
                  >
                  </el-option>
                </el-select> -->
                <el-select v-model="data.Stage" clearable @change="setSn">
                  <el-option v-for="item in machiningStageList" :key="item.MachiningStageId" :value="item.MachiningStageId" :label="item.Name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="工序序号" prop="Sn">
                <span style="padding: 0 15px">{{ data.Sn }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: {
        ProcessId: '',
        ProcessNo: '',
        ProcessName: '',
        Stage: '',
        Sn: ''
      },
      api: require('@/api/production/teProcess').default,
      commonApi: require('@/api/common/common').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      // trendData: iForm.Data,
      ProductionPhaseOptions: [],
      machiningStageList: [],
      rules: {
        ProcessNo: [{ required: true, message: '请输入工序编码' }],
        ProcessName: [{ required: true, message: '请输入工序名称' }],
        Stage: [{ required: true, message: '请选择生产阶段' }]
      }
    }
  },
  created() {
    this.commonApi.getDictionaryList().then(res => {
      this.ProductionPhaseOptions = res.Data.filter(v => {
        return v.Code === 'ProductStage'
      })
    })
    console.log('ProductionPhaseOptions', this.ProductionPhaseOptions)

    this.machiningStageApi.list({ Status: 1 }).then(res => {
      this.machiningStageList = res.Data
    })
  },
  methods: {
    setSn(Stage) {
      if (!this.data.ProcessId) {
        this.api.getMaxSn(Stage).then(Sn => {
          this.data.Sn = Sn
        })
      }
    }
  }
}
</script>
